module.exports = "<a href=\"#guidanceproduct\" class=\"gw-slq-link\">\r\n    <span class=\"gw-slq-link-text\">{{'quoteandbind.views.zip-code.Guidance' | translate }}</span>\r\n</a>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/integration/quoteandbind/guidance/directives/templates/guidance-link.html
// module id = 628
// module chunks = 0